module.exports = __webpack_public_path__ + "img/beaver_swap.ad3a11f5.png";